import type { SyncState } from '@kit/sync/types/sync-state';
import { AlertCircle, Check, CloudOff, KeyRound, Loader2, type LucideIcon, RefreshCw } from 'lucide-react';

type SyncIcon = {
  readonly icon: LucideIcon;
  readonly tone: string;
};

export function syncIcon(state: SyncState, pending: number): SyncIcon {
  switch (state.status) {
    case 'syncing':
      return { icon: Loader2, tone: 'text-muted-foreground animate-spin' };
    case 'offline':
      return { icon: CloudOff, tone: 'text-warn' };
    case 'unauthorized':
      return { icon: KeyRound, tone: 'text-warn' };
    case 'error':
      return { icon: AlertCircle, tone: 'text-danger' };
    default:
      return pending > 0
        ? { icon: RefreshCw, tone: 'text-muted-foreground' }
        : { icon: Check, tone: 'text-ok' };
  }
}
